<app-language-switcher />
<app-loader></app-loader>
<router-outlet></router-outlet>
